<h1>
    <img ngSrc="assets/shared/icons/chevron-left-thick.svg" alt="back icon" height="17" width="10" (click)="back()">
    <button class="button-as-link" (click)="back()">{{ routeBackName | myLbTranslate }}</button>
    <span class="slash">/</span>
    {{ 'system_overview_details' | myLbTranslate }}
</h1>
